import axios, { AxiosStatic } from 'axios';

export class AxiosErrorClass extends Error {
  name = 'AxiosErrorClass';

  protected originalAxiosExeption: object;

  constructor(e) {
    super(e);
    this.originalAxiosExeption = e;
    // eslint-disable-next-line no-restricted-syntax
    for (const key in e) {
      if (Object.prototype.hasOwnProperty.call(e, key)) {
        this[key] = e[key];
      }
    }
  }
}

export default async (Vue, store) => {
  axios.interceptors.request.use((config) => {
    const isAuthenticated = store.getters['auth/isAuthenticated'];
    if (isAuthenticated) {
      const token = store.getters['auth/token'];
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  axios.interceptors.response.use(undefined, (e) => {
    throw new AxiosErrorClass(e);
  });
  axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$http = axios;
};

declare module 'vue/types/vue' {
  interface Vue {
    $http: AxiosStatic;
  }
}
